import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBinoculars = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M4 0a3 3 0 0 1 3 3h2a3 3 0 1 1 6 0v9a3 3 0 1 1-6 0V9H7v3a3 3 0 1 1-6 0V3a3 3 0 0 1 3-3m1 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0m7 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
		clipRule: "evenodd"
	})
});
export default SvgBinoculars;
